<template>

    <div id="legends">
      <div class="legends">
          <div class="legend">
            <span>{{$t('law')}}</span>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'Legends',
  data () {
    return {
      lastValue: '',
      mapHeight: 0,
      layers:[],
      mapDefaultHeight: 550,
      window: {
        width: 0,
        height: 0
      }
    }
  },
  props: [],
  computed: {
  },
  created () {
    // window.addEventListener('resize', this.handleWResize)
    this.$i18n.locale = this.$route.params.locale
  },
  methods: {
    // handleWResize () {
    //   this.window.width = window.innerWidth
    //   this.window.height = window.innerHeight
    //   var mapCont = document.getElementById('legends')
    //   console.log(mapCont)
    // },
    drawLegends(){
      this.layers = {}
      for (var i = 0; i < this.$store.mapParameters.layers.length;i++){
         if (this.$store.mapParameters.layers[i].active){   
            this.layers[this.$store.mapParameters.layers[i]['layer_id']] = this.$store.mapParameters.layers[i]
         }
      }
    }
  }

}
</script>

